var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0171 15.7491L14.7952 10.682H9.93144V7.39375C9.93144 6.00775 10.6106 4.65588 12.7891 4.65588H15V0.342125C15 0.342125 12.9939 0 11.0754 0C7.07025 0 4.45239 2.42725 4.45239 6.82063V10.6829H0V15.75H4.45239V28H9.93144V15.75L14.0171 15.7491Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.cf75809e75055e8825df639e26a20656.svg";
export { ForwardRef as ReactComponent };